import styled from 'styled-components';
import { imageUrl } from 'utils';

export const LoginStyle = styled.div`
    height:100%;
    /* min-width:1920px; */
    min-width:1200px;
    width:100%;

    .login-kfpt{
        display:flex;
        flex-direction:column;
        align-items:center;
        overflow:hidden;

        height:100%;
        width:100%;
        
        background:url(${imageUrl('https://huhuapp-images.huhustory.com/open/Public/Uploads/202006/36d40ae337872df08a555038b0f67c26.jpg')}) no-repeat center;
        background-size:cover;

        .login-header{
            width:100%;
            height:94px;

            background:url(${require('images/home/top.png')}) no-repeat center top;
            background-size:cover;

            .wrapper{
                display:flex;
                justify-content:space-between;
                align-items:center;

                margin:0 auto;
                width:1000px;
                height:94px;

                .login-logo{
                    margin-left:18px;
                    width:197px;
                    height:66px;

                    cursor: pointer;
                }

                .login-header-right{
                    display:flex;
                    align-items:center;

                    .entry{
                        font-size:16px;
                        font-family:SourceHanSansCN-Bold,SourceHanSansCN;
                        font-weight:bold;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }

                    .down{
                        display:flex;
                        justify-content:center;
                        align-items:center;

                        width:111px;
                        height:39px;
                        margin-left:82px;
                        margin-right:31px;

                        background:rgba(255,255,255,1);
                        box-shadow:0px 2px 5px 0px rgba(118,199,236,1);
                        border-radius:20px;
                        font-size:18px;
                        font-family:SourceHanSansCN-Medium,SourceHanSansCN;
                        font-weight:500;
                        color:rgba(115,209,254,1);
                        cursor: pointer;
                    }
                }
            }
        }

        .login-main{
            display:flex;
            justify-content:space-between;
            align-items:center;
            /* overflow-x:auto; */

            width:80%;
            min-width:1000px;
            max-width:1300px;
            margin:10% auto 0;

            .login-img{
                /* width:587px;
                height:454px; */
                /* height:80%; */
                width:400px;
                /* margin-right:298px;
                margin-top:62px; */
            }

            .login-table{
                display:flex;
                flex-direction:column;
                align-items:center;

                width:429px;
                height:518px;
                padding:40px 49px 0 40px;

                background:rgba(255,255,255,0.8);
                box-shadow:0px 2px 15px 0px rgba(112,115,161,0.5);
                border-radius:30px;

                .theme{
                    display:flex;
                    justify-content:space-between;
                    align-items:center;

                    width:100%;

                    .logo{
                        width:95px;
                        height:95px;
                    }

                    .con{
                        display:flex;
                        flex-direction:column;
                        justify-content:center;

                        height:100%;

                        .con-t{
                            margin-bottom:13px;

                            font-size:26px;
                            font-family:PingFangSC-Medium,PingFang SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                        }

                        .con-b{
                            font-size:20px;
                            font-family:PingFangSC-Regular,PingFang SC;
                            font-weight:400;
                            color:rgba(102,102,102,1);
                        }
                    }
                }


                .phone-con{
                    position: relative;
                    
                    width:320px;
                    height:50px;
                    margin:20px 0 20px;

                    .phone{
                        width:320px;
                        height:50px;
                        padding-left:80px;

                        background:rgba(255,255,255,1);
                        border-radius:25px;
                        border:0;
                        outline:0;
                    }

                    .tip{
                        position: absolute;
                        left:39px;
                        /* top:13px; */
                        top:50%;
                        margin-top:-12.5px;

                        font-size:16px;
                        font-family:PingFangSC-Medium,PingFang SC;
                        font-weight:500;
                        color:rgba(153,153,153,1);
                    }

                }

                .captcha{
                    display:flex;
                    justify-content:space-between;
                    align-items:center;

                    width:320px;

                    .captcha-inp{
                        width:154px;
                        height:50px;
                        padding-left:39px;

                        background:rgba(255,255,255,1);
                        border-radius:25px;
                        border:0;
                        outline:0;
                    }

                    .captcha-text{
                        display:flex;
                        align-items:center;
                        justify-content:center;

                        width:138px;
                        height:50px;

                        background:rgba(40,182,255,1);
                        box-shadow:0px 2px 5px 1px rgba(30,179,255,0.41);
                        border-radius:25px;
                        font-size:14px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                }

                .graphic{
                    position: relative;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;

                    width:320px;
                    margin:0 0 20px 0;

                    #code_input{
                        width:154px;
                        height:50px;
                        padding-left:39px;

                        background:rgba(255,255,255,1);
                        border-radius:25px;
                        border:0;
                        outline:0;
                        /* text-align:center; */
                    }

                    .right{
                        position: absolute;
                        top:16px;
                        /* right:12px; */
                        left:115px;

                        width:20px;
                        height:20px;
                    }
                }

                .login-btn{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:320px;
                    height:50px;
                    margin:30px 0 25px;

                    background:rgba(40,182,255,1);
                    box-shadow:0px 2px 5px 1px rgba(40,182,255,0.57);
                    border-radius:25px;
                    font-size:16px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    letter-spacing:3px;
                    cursor: pointer;
                }

                .no-btn{
                    background:#BDBDBD;
                    box-shadow:0px 2px 5px 1px rgba(203,203,203,0.26);
                }

                .login-tip{
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                }

                .login-agree{
                    display:flex;
                    align-items:center;

                    margin-top:11px;

                    .agree{
                        width:12px;
                        height:12px;
                        margin-right:5px;

                        border-radius:50%;
                        border:1px solid #999;
                        cursor: pointer;
                    }

                    .agreement{
                        font-size:12px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(153,153,153,1);

                        >span{
                            text-decoration:underline;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }

    .mask{
        position: fixed;
        top:0;
        left:0;
        z-index:12;

        width:100%;
        height:100%;

        .mask-dg{
            width:100%;
            height:100%;
        }

        .mask-con{
            position: absolute;
            top:200px;
            left:0;
            right:0;
            margin:0 auto;
            z-index:100;
            display:flex;
            flex-direction:column;
            align-items:center;

            width:350px;
            height:353px;

            background:rgba(255,255,255,1);
            box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);
            border-radius:14px;

            .icon{
                margin-top:-108px;
                width:123px;
                height:125px;
            }

            .title{
                /* margin:12px 0 18px; */

                font-size:20px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(51,51,51,1);
            }

            .down{
                margin:20px 0 16px;
                width:250px;
                height:250px;
                
                background:rgba(216,216,216,1);
                border-radius:13px;
            }

            .close{
                position: absolute;
                top:13px;
                right:13px;

                width:16px;
                height:16px;
                cursor: pointer;
            }
        }
    }

    @media screen and (max-width: 1200px) {

        .wrapper{
            width:80%!important;
        }

        /* .login-main{
            justify-content:center!important;
            
            .login-img{
                display:none;
            }

        } */
    }

    @media screen and (max-height: 1000px) {
        min-height:800px;
        overflow:auto;
    }
`;